import MButton from '@assets/mui/@material-extend/MButton';
import palette from '@assets/theme/palette';
import PlusIcon from '@components/icons/Plus';
import TimeIcon from '@components/icons/Time';
import BreadCrumbsHOC, { BreadCrumbProps } from '@components/UI/breadcrumbs';
import CardWrapper from '@components/UI/CardWrapper';
import useMyRouting from '@context/useMyRouting/useMyRouting';
import Typography from '@mui/material/Typography';
import useDelivery from '@pages/AdditionalServices/tabs/DeliveryForm/useDelivery';
import { CALUCLATOR_LINK_BY_LANG_ID } from '@settings/localization/consts';
import React from 'react';

import { CartEmptyComponentStyledContainer } from './StyledComponent';

interface EmptyBasketPlaceholderProps {
  breadCrumbs: BreadCrumbProps[];
  titleText: string;
  subTitleText: string;
  infoText: React.ReactNode;
  calculatorBtnText: string;
  goToApplicationsBtnText: string;
}

function EmptyBasketPlaceholder({
  breadCrumbs,
  titleText,
  subTitleText,
  infoText,
  calculatorBtnText,
  goToApplicationsBtnText,
}: EmptyBasketPlaceholderProps) {
  const { setPage } = useMyRouting().actions;
  const [settings] = useDelivery().useSettings().useState();

  const { primaryLanguageId } = settings;

  const link = CALUCLATOR_LINK_BY_LANG_ID[primaryLanguageId] || CALUCLATOR_LINK_BY_LANG_ID.default;

  const goToCalculator = () => {
    window.open(link, '_self');
    setPage('widget');
  };

  const goToApplications = () => {
    window.open('/personal/requests/?requestsTab=unconfirmed', '_self');
  };

  return (
    <CartEmptyComponentStyledContainer component={'section'}>
      <CardWrapper className="services">
        <BreadCrumbsHOC crumbs={breadCrumbs} />
        {titleText.length !== 0 && (
          <Typography variant={'h1'} color={'common.black'} className={'title'}>
            {titleText}
          </Typography>
        )}
        <Typography variant={'h2'} color={'common.black'} className={'section-title'}>
          {subTitleText}
        </Typography>
        <Typography variant={'body1'} color={'common.black'} className={'section-info'}>
          {infoText}
        </Typography>
        <div className="action-wrapper">
          {goToApplicationsBtnText.length !== 0 && (
            <MButton
              className={'calculation-link applications'}
              onClick={goToApplications}
              fullWidth={true}
              variant={'contained'}
              startIcon={<TimeIcon />}
              size={'large'}
              color={'primary'}
              sx={{
                color: palette.light.text,
                fontSize: 16,
                fontWeight: 600,
              }}
            >
              <span>{goToApplicationsBtnText}</span>
            </MButton>
          )}
          <MButton
            className={'calculation-link'}
            onClick={goToCalculator}
            fullWidth={true}
            variant={'outlined'}
            startIcon={<PlusIcon />}
            size={'large'}
            color={'inherit'}
            sx={{
              color: palette.light.blue[400],
              fontSize: 16,
              fontWeight: 600,
            }}
          >
            <span>{calculatorBtnText}</span>
          </MButton>
        </div>
      </CardWrapper>
    </CartEmptyComponentStyledContainer>
  );
}

export { EmptyBasketPlaceholder };
